import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { Observable } from 'rxjs';

@Injectable()
export class TissueTypeService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<TissueType[]> => {
    return this.apiHttp.get<TissueType[]>("tissuetypes");
  };

  public get = (id: number): Observable<TissueType> => {
    return this.apiHttp.get<TissueType>(`tissuetypes/${id}`);
  };
}

export interface TissueType {
  id: number;
  name: string;
  isActive: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/tissue-type.service.ts